import { render } from "./SupplierDetailExpensesTab.vue?vue&type=template&id=256f21e8&scoped=true"
import script from "./SupplierDetailExpensesTab.vue?vue&type=script&lang=js"
export * from "./SupplierDetailExpensesTab.vue?vue&type=script&lang=js"

import "./SupplierDetailExpensesTab.vue?vue&type=style&index=0&id=256f21e8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-256f21e8"]])

export default __exports__